import axios from 'axios';
import { AppointmentResponse } from '../types/salonTypes';

// API temel URL'i
const API_URL = process.env.REACT_APP_API_URL || 'https://api.345.tr/v1.3';

// Salon web sitesi için API servisi
const apiService = {
  // Slug ile salon web sitesi içeriğini getir
  getWebsiteBySlug: async (slug: string) => {
    try {
      console.log(`[API] Salon web sitesi içeriği getiriliyor (slug: ${slug})...`);
      const response = await axios.get(`${API_URL}/website/public/${slug}`);
      console.log('[API] Website verisi:', response.data);
      
      // Content değerlerini kontrol et
      if (response.data && response.data.website && response.data.website.content) {
        const content = response.data.website.content;
        console.log('[API] Content verisi:', content);
        console.log('[API] serviceDescription:', content.serviceDescription);
        console.log('[API] servicesDescription:', content.servicesDescription);
        
        // Eksik servicesDescription verisini denetleme
        if (!content.servicesDescription && !content.serviceDescription) {
          console.warn('[API] Uyarı: servicesDescription ve serviceDescription değerleri eksik!');
        }
        
        // response.data.website.content içindeki tüm anahtarları loglama
        console.log('[API] Content içindeki tüm anahtarlar:', Object.keys(content));
      } else {
        console.warn('[API] Content verisi bulunamadı veya boş:', response.data);
      }
      
      return response.data;
    } catch (error) {
      console.error('Web sitesi içeriği alınırken hata:', error);
      throw error;
    }
  },

  // Randevu oluştur
  createAppointment: async (appointmentData: any) => {
    try {
      console.log('[API] Randevu oluşturuluyor...', appointmentData);
      const response = await axios.post(`${API_URL}/website/public/appointments`, appointmentData);
      console.log('[API] Randevu oluşturuldu:', response.data);
      return response.data;
    } catch (error) {
      console.error('Randevu oluşturulurken hata:', error);
      
      // Doğrulama gerekiyorsa özel olarak işle
      if (axios.isAxiosError(error) && error.response) {
        const responseData = error.response.data;
        
        // Doğrulama gerektiren özel hata
        if (responseData.requireVerification) {
          console.log('[API] Doğrulama gerekli:', responseData);
          return responseData; // Doğrulama gerektiğini belirten yanıtı döndür
        }
        
        // Doğrulama hatası metni varsa
        if (typeof responseData.message === 'string' && 
            (responseData.message.includes('doğrulanmamış') || 
             responseData.message.includes('doğrulama'))) {
          console.log('[API] Doğrulama hatası tespit edildi:', responseData);
          return {
            success: false,
            message: responseData.message,
            requireVerification: true // Doğrulama gerektiğini belirt
          };
        }
        
        return { 
          success: false, 
          message: responseData.message || 'Randevu oluşturulurken bir hata oluştu'
        };
      }
      
      throw error;
    }
  },
  
  // Salon hizmetlerini getir - website için public endpoint kullan
  getSalonServices: async (salonId: string) => {
    try {
      console.log(`[API] Salon hizmetleri getiriliyor (salonId: ${salonId})...`);
      // Auth gerektiren endpoint yerine public endpoint kullanacağız
      const response = await axios.get(`${API_URL}/website/public/services/${salonId}`);
      console.log('[API] Salon hizmetleri:', response.data);
      return response.data;
    } catch (error) {
      console.error('Salon hizmetleri alınırken hata:', error);
      throw error;
    }
  },
  
  // Salon personellerini getir
  getSalonStaff: async (salonId: string) => {
    try {
      console.log(`[API] Salon personelleri getiriliyor (salonId: ${salonId})...`);
      const response = await axios.get(`${API_URL}/staff/${salonId}`);
      console.log('[API] Salon personelleri:', response.data);
      return response.data;
    } catch (error) {
      console.error('Salon personelleri alınırken hata:', error);
      throw error;
    }
  },
  
  // Rastgele müşteri fotoğrafı getir
  getRandomCustomerPhoto: async (salonId: string) => {
    try {
      console.log(`[API] Rastgele müşteri fotoğrafı getiriliyor (salonId: ${salonId})...`);
      const response = await axios.get(`${API_URL}/photos/random-customer/${salonId}`);
      console.log('[API] Rastgele müşteri fotoğrafı:', response.data);
      return response.data;
    } catch (error) {
      console.error('Müşteri fotoğrafı alınırken hata:', error);
      // Hata durumunda null döndür, böylece frontend varsayılan resmi kullanabilir
      return { success: false, photo: null };
    }
  },
  
  // Salon fotoğraflarını getir
  getSalonPhotos: async (salonId: string, type?: string) => {
    try {
      console.log(`[API] Salon fotoğrafları getiriliyor (salonId: ${salonId}, type: ${type || 'all'})...`);
      const url = type 
        ? `${API_URL}/photos/public?salonId=${salonId}&type=${type}`
        : `${API_URL}/photos/public?salonId=${salonId}`;
      
      const response = await axios.get(url);
      console.log('[API] Fotoğraflar:', response.data);
      return response.data;
    } catch (error) {
      console.error('Salon fotoğrafları alınırken hata:', error);
      return { success: false, photos: [] };
    }
  },
  
  // Salon bilgilerini getir (ID'ye göre)
  getSalonInfo: async (salonId: string) => {
    try {
      console.log(`[API] Salon bilgileri getiriliyor (salonId: ${salonId})...`);
      const response = await axios.get(`${API_URL}/salons/${salonId}`);
      console.log('[API] Salon bilgileri:', response.data);
      return response.data;
    } catch (error) {
      console.error('Salon bilgileri alınırken hata:', error);
      return { success: false, message: 'Salon bilgileri alınamadı', salon: { slug: '' } };
    }
  },
  
  // Website içeriğini getir (ID'ye göre)
  getWebsiteContent: async (salonId: string) => {
    try {
      console.log(`[API] Website içeriği getiriliyor (salonId: ${salonId})...`);
      const response = await axios.get(`${API_URL}/website/content/${salonId}`);
      console.log('[API] Website içeriği:', response.data);
      return response.data;
    } catch (error) {
      console.error('Website içeriği alınırken hata:', error);
      return { success: false, message: 'Website içeriği alınamadı', websiteContent: { slug: '' } };
    }
  },
  
  // Rastgele salon fotoğrafı getir
  getRandomSalonPhoto: async (salonId: string) => {
    try {
      console.log(`[API] Rastgele salon fotoğrafı getiriliyor (salonId: ${salonId})...`);
      const response = await axios.get(`${API_URL}/photos/random/${salonId}?type=salon`);
      console.log('[API] Rastgele salon fotoğrafı:', response.data);
      return response.data;
    } catch (error) {
      console.error('Salon fotoğrafı alınırken hata:', error);
      return { success: false, photo: null };
    }
  },

  // Salon ve personel çalışma günlerini getir
  getWorkingDays: async (salonId: string, staffId?: string) => {
    try {
      console.log(`[API] Salon ve personel çalışma günleri getiriliyor (salonId: ${salonId}, staffId: ${staffId || 'belirtilmedi'})...`);
      const url = staffId 
        ? `${API_URL}/website/public/working-days/${salonId}?staffId=${staffId}`
        : `${API_URL}/website/public/working-days/${salonId}`;
      
      const response = await axios.get(url);
      console.log('[API] Çalışma günleri:', response.data);
      return response.data;
    } catch (error) {
      console.error('Çalışma günleri alınırken hata:', error);
      return { success: false, message: 'Çalışma günleri alınamadı' };
    }
  },
  
  // Belirli bir tarihteki randevu bilgilerini getir
  getAppointments: async (salonId: string, staffId?: string, date?: string): Promise<AppointmentResponse> => {
    try {
      console.log(`[API] Randevular getiriliyor (salonId: ${salonId}, staffId: ${staffId || 'belirtilmedi'}, date: ${date || 'belirtilmedi'})...`);
      
      let url = `${API_URL}/website/public/available-slots/${salonId}`;
      
      // URL parametrelerini ekle
      const params = new URLSearchParams();
      if (staffId) params.append('staffId', staffId);
      if (date) params.append('date', date);
      
      // Parametre varsa URL'ye ekle
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await axios.get(url);
      console.log('[API] Randevular:', response.data);
      return response.data;
    } catch (error) {
      console.error('Randevu bilgileri alınırken hata:', error);
      return { 
        success: false, 
        appointments: [], 
        date: date || new Date().toISOString().split('T')[0],
        message: 'Randevu bilgileri alınamadı' 
      };
    }
  },
  
  // SMS doğrulama kodu gönder
  sendVerificationCode: async (phone: string) => {
    try {
      console.log(`[API] Doğrulama kodu gönderiliyor (phone: ${phone})...`);
      const response = await axios.post(`${API_URL}/website/public/send-verification`, {
        customerPhone: phone
      });
      console.log('[API] Doğrulama kodu gönderildi:', response.data);
      return response.data;
    } catch (error) {
      console.error('Doğrulama kodu gönderilirken hata:', error);
      // Axios hata yanıtından mesaj al
      let errorMessage = 'Doğrulama kodu gönderilemedi';
      
      if (axios.isAxiosError(error) && error.response) {
        const responseData = error.response.data;
        errorMessage = responseData.message || errorMessage;
        console.error('[API] SMS Doğrulama hatası detayı:', responseData);
      }
      
      return { 
        success: false, 
        message: errorMessage
      };
    }
  },
  
  // SMS doğrulama kodunu doğrula
  verifyCode: async (phone: string, code: string) => {
    try {
      console.log(`[API] Doğrulama kodu kontrol ediliyor (phone: ${phone}, code: ${code})...`);
      const response = await axios.post(`${API_URL}/website/public/verify-code`, {
        customerPhone: phone,
        verificationCode: code
      });
      console.log('[API] Doğrulama sonucu:', response.data);
      return response.data;
    } catch (error) {
      console.error('Doğrulama yapılırken hata:', error);
      
      // Axios hata yanıtından mesaj al
      let errorMessage = 'Doğrulama yapılamadı';
      
      if (axios.isAxiosError(error) && error.response) {
        const responseData = error.response.data;
        errorMessage = responseData.message || errorMessage;
        console.error('[API] SMS Doğrulama hatası detayı:', responseData);
      }
      
      return { 
        success: false, 
        message: errorMessage
      };
    }
  }
};

export default apiService; 